enum GameplayerEventType {
  GameCardFavourited = 'game-card-favorited',
  GameCardClicked = 'game-card-clicked',
  // Comet - Domino UI events
  HomeBackButtonClicked = 'back-to-home-btn-clicked',
  HoveringIconShowed = 'hovering-icon-shown',
  HoveringIconClicked = 'hovering-icon-clicked',
  DominoBottomSheetOpened = 'domino-bottom-sheet-opened',
  DominoGameCardClicked = 'domino-game-card-clicked',
  DominoGameFavorited = 'domino-game-favorited',
  GameplayerFullScreenClicked = 'gameplayer-fullscreen-clicked',
  // Game play events
  GamePlayStart = 'game-play-start',
  GamePlayOver = 'game-play-over',
  GameLoadingComplete = 'game-loading-complete',
  GamePlayRetry = 'game-play-retry',
  GamePlayLevelUp = 'game-play-levelup',
  GameLoadingStart = 'game-loading-start',
  GameLoadingDelayed = 'game-loading-delayed',
}

export default GameplayerEventType
